import { useResourceContext, useStore } from 'react-admin';

const FAVORITE_LIST_KEY = 'favorite_list';

type FavoriteFilter = {
  name: string;
  period: string;
  favorite: boolean;
  values: any;
};

export const useFavoriteFilters = () => {
  const resource = useResourceContext();
  const [favorites, setValue] = useStore<FavoriteFilter[]>(`${resource}.${FAVORITE_LIST_KEY}`, []);

  const setFavouriteFilters = (data: FavoriteFilter) => {
    const clearFavorites = favorites?.filter((favorite) => favorite.name !== data.name);

    setValue([...clearFavorites, data]);
  };

  const removeFavoriteFilters = (name: string) => {
    const clearFavorites = favorites?.filter((favorite) => favorite.name !== name);
    setValue(clearFavorites);
  };

  return {
    setFavouriteFilters,
    removeFavoriteFilters,
    favorites,
  };
};
